import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../wayfinder'
/**
* @see \App\Http\Controllers\GlobalSearchController::__invoke
* @see app/Http/Controllers/GlobalSearchController.php:25
* @route '/global-search'
*/
export const search = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

search.definition = {
    methods: ["get","head"],
    url: '/global-search',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\GlobalSearchController::__invoke
* @see app/Http/Controllers/GlobalSearchController.php:25
* @route '/global-search'
*/
search.url = (options?: RouteQueryOptions) => {
    return search.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\GlobalSearchController::__invoke
* @see app/Http/Controllers/GlobalSearchController.php:25
* @route '/global-search'
*/
search.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: search.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\GlobalSearchController::__invoke
* @see app/Http/Controllers/GlobalSearchController.php:25
* @route '/global-search'
*/
search.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: search.url(options),
    method: 'head',
})

const global = {
    search: Object.assign(search, search),
}

export default global